import { memo } from "react"
import { Box, Flex, Stack, Text } from "@chakra-ui/react"
import { Center, AspectRatio, Button, Table, Container, Drawer, CloseButton, Switch, SkeletonText, Separator } from "@chakra-ui/react"
import { LuShoppingCart, LuMessageCircle } from "react-icons/lu"

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { Field } from "@/components/ui/field"
import { formatCurrency } from "@/utilities/number"
import SingleProductPrice from "@/components/product/price/SingleProductPrice"
import TierProductPrice from "@/components/product/price/TierProductPrice"
import { StepperInput } from "@/components/ui/stepper-input"

import ShowLogin from "../ShowLogin";
import VariantOptionValues from "@/pages/product/VariantOptionValues";
import ImagePreview from "@/components/image-preview";

const AddToCartCustom1 = ({ viewModel }) => {
    const {
        openAddToCart,
        setOpenAddToCart,
        loading,
        data,
        selectedVariant,
        selectedOptions,
        itemQuantity,
        setItemQuantity,
        productOptions,
        headingTitle,
        itemCaculatedPrice,
        variantImage,
        lineItems,
        showAddMultiVariant,
        setShowAddMultiVariant,
        showLogin,
        hasChatEntry,
        openChat,
        onSelectOption,
        addToCartClick,
        onLineItemChangeQuantity,
        onItemQuantityClick,
        getStockHint,
        getImageSrc,
    } = viewModel;

    if (!showLogin) {
        return <ShowLogin></ShowLogin>
    }

    return (
        <div>
            <Drawer.Root open={openAddToCart} onOpenChange={(e) => setOpenAddToCart(e.open)} placement="bottom" closeOnEscape={false} closeOnInteractOutside={false} unmountOnExit={true} >
                <Drawer.Backdrop />
                <Drawer.Positioner >
                    <Drawer.Content>
                        <Container maxW={"md"} maxHeight={"100vh"} overflow={"scroll"} style={{ padding: 0 }}>
                            <Drawer.Header>
                                <div style={{ display: "flex", gap: 4 }}>
                                    <div style={{ flexGrow: 1, flexShrink: 1, justifyContent: "center" }}>
                                        <Drawer.Title>Thêm vào giỏ hàng</Drawer.Title>
                                    </div>
                                    <div>
                                        <Drawer.CloseTrigger asChild>
                                            <CloseButton size="lg" />
                                        </Drawer.CloseTrigger>
                                    </div>
                                </div>
                            </Drawer.Header>
                            <Drawer.Body >
                                {loading &&
                                    <SkeletonText noOfLines={5} />
                                }
                                {!loading &&
                                    <>
                                        <Stack gap="4" style={{ paddingBottom: 90 }}>
                                            {selectedVariant &&
                                                <div style={{ display: "flex", gap: 8 }}>
                                                    <div style={{ flex: 0.6 }}>
                                                        <AspectRatio ratio={4 / 3}>
                                                            {variantImage &&
                                                                <ImagePreview
                                                                    src={getImageSrc(variantImage)}
                                                                    alt={headingTitle || "Hình ảnh biến thể"}
                                                                    imageProps={{
                                                                        w: "100%",
                                                                        h: "100%",
                                                                        objectFit: "cover",
                                                                        borderRadius: "md"
                                                                    }}
                                                                />
                                                            }
                                                        </AspectRatio>
                                                    </div>
                                                    <div style={{ flex: 0.4 }}></div>
                                                </div>
                                            }

                                            {!selectedVariant &&
                                                <div style={{ display: "flex", gap: 8 }}>
                                                    <div style={{ flex: 0.6 }}>
                                                        <AspectRatio bg="bg.muted" ratio={4 / 3}>
                                                            <Center>Chọn một phân loại</Center>
                                                        </AspectRatio>
                                                    </div>
                                                </div>
                                            }
                                            <Separator ></Separator>
                                            {data.variants.length > 1 &&
                                                <>
                                                    {productOptions.map((x, index) => {
                                                        return (
                                                            <Field label={x.title} required key={x.id || index}>
                                                                <VariantOptionValues
                                                                    option={x}
                                                                    optionIndex={index}
                                                                    selectedOption={selectedOptions[index]}
                                                                    variants={data.variants || []}
                                                                    onSelectOption={onSelectOption}
                                                                />
                                                            </Field>
                                                        )
                                                    })}
                                                </>
                                            }

                                            {!showAddMultiVariant &&
                                                <>
                                                    <Separator ></Separator>
                                                    <Field orientation="horizontal" label="Số Lượng" required >
                                                        <StepperInput
                                                            value={itemQuantity}
                                                            onValueChange={e => { setItemQuantity(e.valueAsNumber) }}
                                                            max={data.track_inventory && !data.allow_backorder && selectedVariant ? (selectedVariant.available_quantity ?? 0) : undefined}
                                                        ></StepperInput>
                                                    </Field>
                                                    {getStockHint(selectedVariant?.available_quantity, itemQuantity) !== null &&
                                                        <Center fontSize="sm" color="red.500">
                                                            Chỉ còn {getStockHint(selectedVariant?.available_quantity, itemQuantity)} sản phẩm
                                                        </Center>
                                                    }
                                                </>
                                            }

                                            <Separator ></Separator>
                                            <div>
                                                <div>
                                                    {selectedVariant &&
                                                        <div>
                                                            {selectedVariant.price_list?.length > 0 ? (
                                                                <TierProductPrice
                                                                    priceList={selectedVariant.price_list}
                                                                    onPriceItemClick={onItemQuantityClick}
                                                                />
                                                            ) : (
                                                                <SingleProductPrice
                                                                    price={itemCaculatedPrice}
                                                                    originalPrice={selectedVariant?.original_price}
                                                                />
                                                            )}
                                                        </div>
                                                    }
                                                    <div style={{ marginTop: 8, display: lineItems.length > 1 ? "block" : "none" }}>
                                                        <Flex justifyContent={"flex-end"}>
                                                            <Switch.Root
                                                                checked={showAddMultiVariant}
                                                                onCheckedChange={(e) => setShowAddMultiVariant(e.checked)}
                                                                size={"sm"}
                                                            >
                                                                <Switch.HiddenInput />
                                                                <Switch.Control />
                                                                <Switch.Label>Chọn nhiều phân loại</Switch.Label>
                                                            </Switch.Root>
                                                        </Flex>
                                                    </div>

                                                    {showAddMultiVariant &&
                                                        <div>
                                                            <Table.Root size="sm">
                                                                <Table.ColumnGroup>
                                                                    <Table.Column />
                                                                    <Table.Column htmlWidth="75px" />
                                                                    <Table.Column htmlWidth="95px" textAlign={"right"} />
                                                                </Table.ColumnGroup>

                                                                <Table.Body>
                                                                    {lineItems.map(v => {
                                                                        return (
                                                                            <Table.Row key={v.product_id}>
                                                                                <Table.Cell>
                                                                                    <div>{v.variant_title}</div>
                                                                                    {v.out_of_stock
                                                                                        ? <div style={{ color: "var(--chakra-colors-red-400)", fontSize: "0.8em" }}>Hết hàng</div>
                                                                                        : getStockHint(v.available_quantity, v.quantity) !== null && <div style={{ fontSize: "0.8em", color: "var(--chakra-colors-red-500)" }}>Chỉ còn {getStockHint(v.available_quantity, v.quantity)}</div>
                                                                                    }
                                                                                </Table.Cell>
                                                                                <Table.Cell textAlign="end">
                                                                                    {v.out_of_stock
                                                                                        ? <span style={{ color: "var(--chakra-colors-gray-400)", fontSize: "0.85em" }}>—</span>
                                                                                        : <StepperInput
                                                                                            min={0}
                                                                                            max={data.track_inventory && !data.allow_backorder ? (v.available_quantity ?? 0) : undefined}
                                                                                            value={v.quantity}
                                                                                            onValueChange={e => onLineItemChangeQuantity(v.product_id, e.valueAsNumber)}
                                                                                        ></StepperInput>
                                                                                    }
                                                                                </Table.Cell>
                                                                                <Table.Cell style={{ textAlign: "right" }}>{v.out_of_stock ? "" : formatCurrency(v.price)}</Table.Cell>
                                                                            </Table.Row>
                                                                        )
                                                                    })}
                                                                </Table.Body>
                                                            </Table.Root>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </Stack>
                                        <div style={{ position: "fixed", bottom: 0, left: 0, width: "100vw" }}>
                                            <Container maxW={"md"} style={{ padding: 0 }} >
                                                <Box bg="bg" shadow="md" borderRadius="md" style={{ padding: 8 }}>
                                                    {(data.out_of_stock || (!showAddMultiVariant && !!selectedVariant && !!data.track_inventory && !data.allow_backorder && (selectedVariant.available_quantity ?? 0) <= 0)) &&
                                                        <div style={{ paddingBottom: 8 }} >
                                                            <Center color={"red.400"} style={{ padding: 8 }}>
                                                                Sản phẩm này tạm thời hết hàng
                                                            </Center>
                                                            {hasChatEntry &&
                                                                <Center fontSize="xl" >
                                                                    <Button
                                                                        variant={"outline"}
                                                                        onClick={() => openChat({
                                                                            chatAttachment: {
                                                                                type: "product",
                                                                                title: data?.name,
                                                                                meta: { product_id: data?.id },
                                                                                url: data?.images?.[0]?.url,
                                                                            }
                                                                        })}
                                                                    >
                                                                        <LuMessageCircle></LuMessageCircle> Nhận thông báo khi có hàng
                                                                    </Button>
                                                                </Center>
                                                            }
                                                        </div>
                                                    }
                                                    {!(data.out_of_stock || (!showAddMultiVariant && !!selectedVariant && !!data.track_inventory && !data.allow_backorder && (selectedVariant.available_quantity ?? 0) <= 0)) &&
                                                        <Flex gap="2" style={{ height: 50 }}>
                                                            <div style={{ flex: 0.4 }}>
                                                                <Center h="100%" px="2">
                                                                    {selectedVariant &&
                                                                        <Text fontWeight="600" color="red.500" fontSize="md" textAlign="center">
                                                                            {selectedVariant.price_list?.length > 0
                                                                                ? `${Number(itemCaculatedPrice || 0).toLocaleString("vi-VN")}đ`
                                                                                : `${Number(selectedVariant.original_price || 0).toLocaleString("vi-VN")}đ`}
                                                                        </Text>
                                                                    }
                                                                </Center>
                                                            </div>

                                                            <div>
                                                                <Center fontSize="xl" h="100%">
                                                                    <Separator orientation="vertical" height="4" />
                                                                </Center>
                                                            </div>

                                                            <div style={{ flex: 0.6 }}>
                                                                <Center fontSize="xl" h="100%" onClick={addToCartClick}>
                                                                    <Button variant="solid">
                                                                        <LuShoppingCart /> Thêm vào giỏ hàng
                                                                    </Button>
                                                                </Center>
                                                            </div>
                                                        </Flex>
                                                    }
                                                </Box>
                                            </Container>
                                        </div>
                                    </>
                                }
                            </Drawer.Body>
                            <Drawer.CloseTrigger />
                        </Container>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Drawer.Root>
        </div>
    )
}

export default memo(AddToCartCustom1)
